import { Formik, Form } from 'formik'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { AuthSchema } from '@validations'
import Column from '@components/column'
import Button from '@components/button'
import Fields from '@components/fields'
import { Category, User } from '@apis'
import { Constant } from '@utils'
import ChooseSpecializations from '@commons/specializations'
const ProfileForm = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const { data: departments } = useSelector((state: any) => state.departments)
  const [initialValues, setInitialValues] = useState<any>({
    coverImage: '',
    avatar: '',
    name: '',
    phoneNo: '',
    countryCode: '',
    email: '',
    address: '',
    departments: [],
    yos: '',
    specializations: [],
    instituteType: '',
    serviceIncludes: [],
  })
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values) => {
    setLoading(true)
    const payload: any = {
      name: values?.name,
      infos: {
        yos: values?.yos,
        address: values?.address,
        instituteType: values?.instituteType,
      },
    }
    if (!!values?.serviceIncludes || values?.serviceIncludes?.length) {
      payload.infos = {
        ...payload.infos,
        serviceIncludes: values?.serviceIncludes,
      }
    }
    if (values?.avatar?.base64) {
      payload.avatar = {
        base64: values?.avatar?.base64,
        extension: values?.avatar?.extension,
      }
    }
    if (values?.coverImage?.base64) {
      payload.infos = {
        ...payload.infos,
        coverImage: {
          base64: values?.coverImage?.base64,
          extension: values?.coverImage?.extension,
        },
      }
    }
    if (!!values?.departments) {
      payload.departments = values?.departments
    }
    if (!!values?.specializations?.length) {
      payload.specializations = values.specializations?.map(
        (specialization) => specialization.id,
      )
    }
    await User.update({
      data: payload,
      id: user?.id,
    }).catch(() => {})
    setLoading(false)
  }

  const fetchDepartments = async () => {
    await Category.list({
      state: 'departments',
      params: {
        type: 'Department',
      },
    }).catch(() => {})
  }

  useEffect(() => {
    setInitialValues({
      coverImage: user?.infos?.coverImage,
      avatar: user?.avatar,
      name: user?.name,
      phoneNo: user?.phoneNo,
      countryCode: user?.countryCode,
      email: user?.email,
      address: user?.infos?.address,
      departments: user?.departments?.map((department: any) => department?.id),
      specializations: user?.specializations,
      yos: user?.infos?.yos,
      instituteType: user?.infos?.instituteType,
      serviceIncludes: user?.infos?.serviceIncludes,
    })
    if (!departments?.length) {
      fetchDepartments()
    }
  }, [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      enableReinitialize
      validationSchema={AuthSchema.institutionStep2ValidationSchema}
    >
      {({ handleSubmit, values, setFieldValue, errors }: any) => {
        return (
          <Form onSubmit={handleSubmit}>
            <Column rowGap={15}>
              <Column styleColumn="margin-bottom:60px;position:relative;">
                <Fields.Upload
                  varient="banner"
                  name="coverImage"
                  size={200}
                  styleWrapper="
                    img{
                        border-radius:8px;
                    }
                "
                />
                <Fields.Upload
                  varient="avatar"
                  name="avatar"
                  size={80}
                  styleWrapper="position:absolute;bottom:-40px;"
                />
              </Column>
              <Column
                bg="white"
                styleColumn="padding:15px 20px;border-radius:8px;"
                rowGap={15}
              >
                <Fields.Input
                  name="name"
                  placeholder="Enter Full Name"
                  label="Full Name"
                />
                <Fields.PhoneInput
                  name="phoneNo"
                  placeholder="Enter Mobile Number"
                  label="Mobile Number"
                  disabled
                />
                <Fields.Input
                  type="email"
                  name="email"
                  placeholder="Enter Email Address"
                  label="Email"
                  disabled
                />
                <Fields.Input
                  name="address"
                  placeholder="Enter Address"
                  label="Address"
                />
                <Fields.DropDown
                  name="departments"
                  titleAsKey="name"
                  valueAsKey="id"
                  options={departments}
                  placeholder="Select Your Department"
                  label="Department"
                  hasSearch
                  isMultiple
                />
                <ChooseSpecializations
                  isError={errors?.specializations}
                  selectedItems={values?.specializations}
                  onChange={(item: any) => {
                    const findIndex = values?.specializations?.findIndex(
                      (selected: any) => selected?.id == item.id,
                    )
                    if (findIndex >= 0) {
                      setFieldValue(
                        'specializations',
                        values?.specializations?.filter(
                          (symptom) => symptom?.id != item?.id,
                        ),
                      )
                    } else {
                      setFieldValue('specializations', [
                        ...values?.specializations,
                        item,
                      ])
                    }
                  }}
                />
                <Fields.DropDown
                  options={Constant.instituteTypes}
                  titleAsKey="label"
                  valueAsKey="value"
                  placeholder="Select Institute Type"
                  label="Institute Type"
                  name="instituteType"
                />
                <Fields.Map
                  name="serviceArea"
                  label="Delivery Range"
                  placeholder="Delivery Range"
                />
                <Fields.Input
                  type="number"
                  name="yos"
                  placeholder="Year of Service"
                  label="Year of Service"
                />
                <Fields.GroupCheckBox
                  label="Service Includes"
                  name="serviceIncludes"
                  options={Constant.services}
                  titleAsKey="label"
                  valueAsKey="value"
                />

                <Button
                  type="submit"
                  title="Update Profile"
                  styleButton="width:100%;"
                  height={45}
                  loading={loading}
                />
              </Column>
            </Column>
          </Form>
        )
      }}
    </Formik>
  )
}

export default ProfileForm
